// Client for the QMS dashboard: everything the landing page draws, in one read (t1/v1/dashboard,
// cres_t1/service/dashboard.py). Four sections: what needs this person, the account's state counts,
// supplier documents, and the bell's own feed as recent activity.
import {makeCresAxiosFoundationAPI} from "../util/AxiosFoundationAPI";

export type ApprovalRow = {RecordUSID: string; ObjectID: string | null; Name: string | null; Revision: string | null; ObjectTypeName: string | null; Stage: number | null; Since: string | null};
export type TrainingRow = {ObjectRevisionUSID: string; ObjectID: string | null; Name: string | null; State: "OUTSTANDING" | "OVERDUE"; Due: string | null; DaysOverdue: number | null};
export type ChangeOrderRow = {USID: string; ChangeOrderID: string; Title: string; State: string; LastModified: string | null};
export type DraftRow = {USID: string; ObjectID: string | null; Name: string | null; DisplayRevision: string | null; Classification: string; LastModified: string | null};
export type TrendRow = {Week: string; Opened: number; Closed: number};
export type ActivityRow = {USID: string; Type: string; Title: string; Body: string; When: string | null; Read: boolean; Url: string | null};

export type Dashboard = {
    Mine: {
        Approvals: {Count: number; Shown: ApprovalRow[]; Route: string};
        Training: {Count: number; Overdue: number; Shown: TrainingRow[]; Route: string};
        ChangeOrders: {Count: number; Shown: ChangeOrderRow[]; Route: string};
        Drafts: {Count: number; Shown: DraftRow[]};
    };
    Account: {
        QualityRecords: {Open: number; ByKind: {Kind: string; Open: number; ByState: Record<string, number>}[]; Aging: {Under30: number; From30To90: number; Over90: number}};
        ChangeOrders: {Open: number; ByState: Record<string, number>};
        Approvals: {Waiting: number; Blocked: number};
        Revisions: {Drafts: number; Released: number; PendingChange: number};
        Trend: {Weeks: number; Rows: TrendRow[]};
    };
    Suppliers: {Documents: number; Expired: number; ExpiringSoon: number; ExpiryUnknown: number; WithinDays: number; Route: string} | null;
    Activity: ActivityRow[];
    Today: string;
};

export async function fetchDashboard(api: ReturnType<typeof makeCresAxiosFoundationAPI>, weeks = 12): Promise<Dashboard> {
    const response = await api({method: "GET", url: "t1/v1/dashboard", params: {WeeksOfTrend: weeks}});
    return response.data as Dashboard;
}

/** "3 days ago", "today", "in 5 days" -- for a timestamp the server produced. */
export function relativeDay(iso: string | null | undefined, today: string): string {
    if (!iso) return "";
    const day = iso.slice(0, 10);
    const diff = Math.round((Date.parse(day) - Date.parse(today)) / 86_400_000);
    if (Number.isNaN(diff)) return "";
    if (diff === 0) return "today";
    if (diff === -1) return "yesterday";
    if (diff === 1) return "tomorrow";
    return diff < 0 ? `${-diff} days ago` : `in ${diff} days`;
}
